module.exports = __webpack_public_path__ + "files/ville.abbf6067bd9b29104b7afa4ead4c4a9c.pdf";